import api from './api'

const postsPerPage = 99
const headers = api.nonce ? {headers: {'X-WP-Nonce': api.nonce} } : {}

export const postEndPoint = async (endPoint,body) => {
    const url = `${api.url}/${endPoint}`
  
    const response = await fetch(url,{
        headers:        {'X-WP-Nonce': api.nonce, 'Content-Type': 'application/json'},
        method:         "POST",
        body:           JSON.stringify(body)
    })

    const responseJson = await response.json()
    if(responseJson.code &&  responseJson.data){
        throw responseJson;
    }
    return responseJson;
  
}

export const fetchEndPoint = async (endPoint) => {
    const url = `${api.url}/${endPoint}`

    const response = await fetch(url,headers)
    const responseJson = await response.json()
    if(responseJson.code &&  responseJson.data){
        throw responseJson;
    }
    return responseJson;

}

export const deleteEndPoint = async (endPoint) => {
    const url = `${api.url}/${endPoint}?_wpnonce=${api.nonce}`
    console.log(url)
    const response = await fetch(url,{
        headers:        headers,
        method:         "DELETE"
    })
    const responseJson = await response.json()
    if(responseJson.code &&  responseJson.data){
        throw responseJson;
    }
    return responseJson;
}

export const deletePost = async (id, type = "posts") => {
    return await deleteEndPoint(`${type}/${id}`)
}

export const fetchPost = async (id, type = "posts") => {
    return await fetchEndPoint(`${type}/${id}`)
}

export const fetchPage = async (url,page,perPage) => {
    const urlConcat = url.indexOf("?") === -1 ? "?" : "&"
    const urlString = `${url}${urlConcat}per_page=${encodeURIComponent(perPage)}&page=${encodeURIComponent(page)}` 
    const response = await fetch(urlString,headers)
    return response.json()
}

export const fetchAllPages = async (apiEndPoint,onPageLoad = () => {}) =>  {
    const url = `${api.url}/${apiEndPoint}`
    let allObjects = []
    let page = 1
    do{
        const objects = await fetchPage(url,page,postsPerPage)
        if( typeof objects.code !== 'undefined' ){
            if( objects.code === 'rest_post_invalid_page_number' ) break;

            throw objects;
        }
        if( objects.length === 0 ) break;
        allObjects = [...allObjects, ...objects]
        onPageLoad(allObjects)
        if( objects.length < postsPerPage ) break;
        page += 1
    }while(allObjects.length%postsPerPage===0 && allObjects.length>0 )
    return allObjects;
}

export const getOldestPost = async (type = "post") => {
    const response = await fetch(`${api.url}/${type}?per_page=1&page=1&order=asc`,headers)
    const responseJson = await response.json()
    if(responseJson.code &&  responseJson.data){
        throw responseJson;
    }
    return responseJson;  
}

export const getLoginUrl = () => {
    return api.login_url;
}

